import { useMemo } from 'react';
import type { OrganizationModel } from 'shared/domain/organization/types/model';
import { useEntityCollectionInitializer } from '../../entityCollection';
import { useOrganizationsStore } from '../store';
import type { OrganizationsActions } from '../types';

/**
 * Loads the organizations and keeps them current. Reopened on project change:
 * the worker clears its organizations with the project data.
 */
export function useOrganizationsInitializer(): void {
  useEntityCollectionInitializer(useOrganizationsStore.use.actions());
}

/** Organizations by id, with their loading state. */
export function useOrganizations(): {
  organizationsMap: Map<string, OrganizationModel>;
  loading: boolean;
} {
  const { items, loading } = useOrganizationsStore.use.data();
  const organizationsMap = useMemo(
    () => new Map(items.map((organization) => [organization._id, organization])),
    [items]
  );
  return useMemo(() => ({ organizationsMap, loading }), [organizationsMap, loading]);
}

/** Organizations actions (stable references). */
export function useOrganizationsActions(): OrganizationsActions {
  return useOrganizationsStore.use.actions();
}
